<div class="payment-failed-content text-center px-3 pt-4 mx-auto">
  <img
    *ngIf="variant === 'success'; else errorIcon"
    class="payment-success-icon d-block mx-auto mb-3"
    [src]="successImageUrl"
    alt=""
  />
  <ng-template #errorIcon>
    <i
      class="fa fa-exclamation-circle payment-error-icon d-block mx-auto mb-3"
    ></i>
  </ng-template>
  <div class="payment-failed-title font-weight-bold font-size-header">
    {{ titleKey | translate: titleParams }}
  </div>
  <div class="payment-failed-subtitle mt-4 font-size-primary mx-auto">
    {{ subtitleKey | translate: subtitleParams }}
  </div>
  <div
    *ngIf="showCountdown"
    class="countdown-circle mx-auto mt-4 d-flex align-items-center justify-content-center"
    [style.background]="getCountdownBackground(countdown)"
  >
    <span class="countdown-text">{{ countdown }}</span>
  </div>
</div>
